<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <PropertyTypeListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import PropertyTypeListing from "@/views/pages/admin/propertyType/propertyTypeListing";

export default {
    page: {
        title: i18n.t("module.propertyType"),
    },
    components: { Layout, PageHeader, PropertyTypeListing },
    data() {
        return {
            title: i18n.t("module.propertyType"),
            items: [
                {
                    text: i18n.t("module.property"),
                    href: '/properties',
                },
                {
                    text: i18n.t("module.propertyType"),
                    active: true,
                },
            ],
        };
    },
}
</script>
